<template>
    <div>
        <breadcrumb :routerList="[{to:'/establish/etBellingList',title:'返利管理'},{title:'开票详情'}]"/>
        <div class="h-content">

            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="链群" prop="rebateChainGroup" >
							    <!--<el-input style="width:1.6rem" v-model="q.pipeiLianqunLike" placeholder="请输入"></el-input>-->
							    <brselect
							            ref="rebateChainGroup"
							            clearable category="rebate_chain_group"
							            :v="q.rebateChainGroup"
							            v-model="q.rebateChainGroup">
							    </brselect>
							</el-form-item>
							<el-form-item label="发票号" prop="vbelnLike">
							    <el-input v-model="q.vbelnLike" placeholder="请输入"></el-input>
							</el-form-item>
							
							<el-form-item label="产品编码" prop="matnrLike">
							    <el-input v-model="q.matnrLike" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="产品型号" prop="maktxLike">
							    <el-input v-model="q.maktxLike" placeholder="请输入"></el-input>
							</el-form-item>
							
						</div>
						<div class="h-formBtnOut h-columnCenter">
						    <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						    <el-button @click="qingkong" class="h-btn h-formBtn h-bgwhite">重置
						    </el-button>
						</div>
                        <!--<el-form-item label="合同开始时间">-->
                        <!--<el-input v-model="q.contractStartTime"></el-input>-->
                        <!--</el-form-item>-->
                        <!--<el-form-item label="合同结束时间">-->
                        <!--<el-input v-model="q.contractEndTime"></el-input>-->
                        <!--</el-form-item>-->
                        
                        <!--                        <el-form-item class="h-formBtnOut">-->
                        <!--                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="addPrice" >新增经销商合同</el-button>-->
                        <!--                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="daoruExcel" >导入</el-button>-->
                        <!--                        </el-form-item>-->
                    </el-form>
                </div>
            </div>

            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table @selection-change="handleSelectionChange"
                          ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                          :border="true"
						  max-height="510"
                >
                    <!--<el-table-column-->
                            <!--type="selection"-->
							<!--fixed-->
                    <!--&gt;-->
                    <!--</el-table-column>-->
                    <el-table-column
                            type="index"
                            label="#"
							fixed
                            width="40">
                    </el-table-column>

                    <el-table-column
                            prop="kunrg"
                            :show-overflow-tooltip="true"
                            label="客户编号"
							fixed
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="kunrgT"
                            :show-overflow-tooltip="true"
                            label="客户名称"
                            min-width="180"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="year"
                            :show-overflow-tooltip="true"
                            label="年"
                            width="100"
                            v-if="1>2"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="month"
                            :show-overflow-tooltip="true"
                            label="月"
                            width="100"
                            v-if="1>2"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="lianqun"
                            :show-overflow-tooltip="true"
                            label="链群"
                            width="120">
                        <template slot-scope="scope">
                            {{scope.row.lianqun|dictname('rebate_chain_group')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="vbeln"
                            :show-overflow-tooltip="true"
                            label="发票号"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="erdat"
                            :show-overflow-tooltip="true"
                            label="开票日期"
                            width="160">
                    </el-table-column>

                    <el-table-column
                            prop="matnr"
                            :show-overflow-tooltip="true"
                            label="产品编码"
                            width="150"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="maktx"
                            :show-overflow-tooltip="true"
                            label="产品型号"
                            min-width="180"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="fkimg"
                            :show-overflow-tooltip="true"
                            label="产品数量"
                            width="90"
                    >
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--prop="zp00"-->
                            <!--:show-overflow-tooltip="true"-->
                            <!--label="基准价"-->
                            <!--width="90"-->
                    <!--&gt;-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                            <!--prop="wrbtr"-->
                            <!--:show-overflow-tooltip="true"-->
                            <!--label="价税合计"-->
                            <!--width="90"-->
                    <!--&gt;-->
                    <!--</el-table-column>-->
                    <el-table-column
                            prop="wrbtr"
                            :show-overflow-tooltip="true"
                            label="销额"
                            width="90"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="rebateBase"
                            :show-overflow-tooltip="true"
                            label="基数"
                            width="90"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="rebateCoefficient"
                            :show-overflow-tooltip="true"
                            label="返利系数(%)"
                            width="130"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="jiangli"
                            :show-overflow-tooltip="true"
                            label="奖励金额"
                            width="90"
                    >
                        <template slot-scope="scope">
                            <div>{{new big(Number(scope.row.jiangli).toFixed(0))}}</div>
                        </template>
                        <!--<template slot-scope="scope">-->
							<!--<div>{{scope.row.rebateCoefficient*scope.row.wrbtr}}</div>-->
                            <!--&lt;!&ndash;tableData.wrbtr*rebateCoefficient&ndash;&gt;-->
                        <!--</template>-->
                    </el-table-column>
                    <el-table-column
                            prop="aubel"
                            :show-overflow-tooltip="true"
                            label="so订单号"
                            width="180"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="vkorg"
                            :show-overflow-tooltip="true"
                            label="销售组织"
                            width="180"
                    >
                        <template slot-scope="scope">
                            {{scope.row.vkorg|dictname('YLSalesOrganization_agent')}}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">

                    <div class="h-pagination2">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
            <!--展示表格-->
            <div class="h-table h-mrt30">
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcelDetail" v-auth="'flmx_daochu'">返利明细导出
                        </el-button>
                    </div>

                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgblueQ2"   @click="goback">返回</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'


    export default {
        data() {
            return {
                tableData: [],
                q: {
                    rebateChainGroup:'',
                    vbelnLike:'',
                    matnrLike:'',
                    maktxLike:'',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    type:'',
                },
                //表格
                multipleSelection: [],
            }
        },
        created() {
            this.query();
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/establish/fanliJisuanSAP' && from.path == '/establish/etBellingList'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            qingkong(){
                this.q.vbelnLike='';
                this.q.rebateChainGroup='';
                this.q.maktxLike ='';
                this.q.matnrLike='';
            },
            query() {
                this.q.kunrg = this.$route.query.customerId;
                this.q.lianqun = this.$route.query.lianqun;
                this.q.year = this.$route.query.year;
                this.q.month = this.$route.query.month;
              this.q.type = this.$route.query.type;
                //this.q.rebateCoefficient = this.$route.query.rebateCoefficient;
                ss.fanli.queryNewEtBilling(this.q).then(res => {
                    console.log(res, "开票数据")
					// for(var i=0;i<res.records.length;i++){
					// 	if(this.$route.query.rebateCoefficient){
					// 		res.records[i].rebateCoefficient = this.$route.query.rebateCoefficient
					// 	}
					// }
                    for(var i=0;i<res.records.length;i++){
                        if(this.$route.query.month){
                            res.records[i].month = this.$route.query.month
                        }
                    }
                    // for(var i=0;i<res.records.length;i++){
                    //     if(this.$route.query.rebateBase){
                    //         res.records[i].rebateBase = this.$route.query.rebateBase
                    //     }
                    // }
                    for(var i=0;i<res.records.length;i++){
                        if(this.$route.query.year){
                            res.records[i].year = this.$route.query.year
                        }
                    }
                    this.tableData = res.records;
                    this.q.total = res.total;
                })
            },
            goback(){
                this.$router.go(-1)
            },
            // query(){
            //     this.q.kunrg = this.$route.query.customerId;
            //     this.q.lianqun = this.$route.query.lianqun;
            //     this.q.year = this.$route.query.year;
            //     this.q.month = this.$route.query.month;
            //     ss.fanli.queryNewEtBilling(this.q).then(res => {
            //         console.log(res, "开票数据")
				// 	for(var i=0;i<res.records.length;i++){
				// 		if(this.$route.query.rebateCoefficient){
				// 			res.records[i].rebateCoefficient = this.$route.query.rebateCoefficient/100
				// 		}
				// 	}
            //         this.tableData = res.records;
            //         this.q.total = res.total;
            //     })
            // },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection, "WWWWWWWWWW")
            },
            //开票明细批量导出
            exportExcelDetail() {
                var idlist = [];
                this.q.year = this.$route.query.year;
                this.multipleSelection.forEach(element => {
                    idlist.push(element.vbeln+","+element.year+","+element.month+","+element.kunrg+","+element.lianqun);
                });
                if (idlist.length != 0) {
                    console.log(idlist+"!!!!!!!!!!!!!!")
                    updownfile.down("/api/swyl/v1/demo/newEtBilling/downloadExcelIdDetail", idlist, "post", 'data');
                } else {
                    updownfile.down("/api/swyl/v1/demo/newEtBilling/downloadExcelEntityDetail", this.q, "post");
                }

            },
            handleFilter(){
                this.query();
            }


        }
    }
</script>
<style>

</style>